import { render, staticRenderFns } from "./video-utube.vue?vue&type=template&id=c97f111a"
import script from "./video-utube.vue?vue&type=script&lang=js"
export * from "./video-utube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports